import { render } from "./RoundedBox.vue?vue&type=template&id=44675aa6"
import script from "./RoundedBox.vue?vue&type=script&lang=js"
export * from "./RoundedBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RoundedBox.vue?vue&type=style&index=0&id=44675aa6&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__